export default __webpack_public_path__ + "static/media/sciencebowl_card.879527d6.png";